import { createSelector } from "reselect";

export const selectTagList = (state) => state.tags.tagList

export const getDefaultTag = createSelector(
    selectTagList,
    (tagList) => {
        return tagList.find(tag => tag.isDefault)
    },
);